<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <form-item-group
      title="Scrolling Boxes"
      :min="CONSTANT.CREATIVE_DEFAULT_VALUE.SCROLLINGBOX.MIN_NUM"
      :max="CONSTANT.CREATIVE_DEFAULT_VALUE.SCROLLINGBOX.MAX_NUM"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.SCROLLINGBOX.ITEM"
      v-model="item.scrolling_boxes"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image"
          :prop="`scrolling_boxes.${index}.image_url`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.scrolling_boxes[index].image_url"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          :prop="`scrolling_boxes.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input
            v-model="item.scrolling_boxes[index].landing_page"
          ></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <el-form-item label="Bottom Offset" label-width="137px">
      <Offset v-model="item.offset_bottom"> </Offset>
    </el-form-item>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
const { SCROLLINGBOX } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      item: {
        scrolling_boxes: [...Array(SCROLLINGBOX.MIN_NUM)].map(() =>
          _.cloneDeep(SCROLLINGBOX.ITEM)
        ),
        offset_bottom: {
          number: "",
          unit: "px",
        },
      },
      limited_size: {
        image: {
          width: {
            max: 320,
            min: 320,
          },
          height: {
            max: 80,
            min: 80,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.scrolling_boxes = _.map(
        row.scrolling_boxes,
        (scrolling_box) => {
          return {
            image_url: decodeURI(scrolling_box.image_url),
            landing_page: decodeURI(scrolling_box.landing_page),
          };
        }
      );
      this.item.offset_bottom.unit = row.offset_bottom_unit;
      this.item.offset_bottom.number = row.offset_bottom_number;
    },
    async getData(setObj) {
      setObj.scrolling_boxes = _.map(
        this.item.scrolling_boxes,
        (scrolling_box) => {
          return {
            image_url: scrolling_box.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
            landing_page: scrolling_box.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
          };
        }
      );
      setObj.offset_bottom_unit = this.item.offset_bottom.unit;
      setObj.offset_bottom_number = this.item.offset_bottom.number;
      return setObj;
    },
  },
};
</script>

<style></style>
